module.exports = __webpack_public_path__ + "static/media/aboutUs_05.d422cd3b.jpg";